import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { AGENCY_PERFERMANCE_OVERVIEW_REPORT } from '../endpoint';
import { AgencyPerfermanceOverviewReportRequestModel } from '../models/AgencyPerfermanceOverviewReportPage';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: AgencyPerfermanceOverviewReportRequestModel): Promise<void> => {
    return await axios
      .get(`${AGENCY_PERFERMANCE_OVERVIEW_REPORT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'agency-perfermance-overview-report',
        });
      });
  };
